import { extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { HtmlHeadings } from '../../utils/types.js';
import { sanitize } from '../../utils/sanitize.js';
import { ChoiceCard } from './ChoiceCard.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.js';
import { HelpText } from '../HelpText/HelpText.js';
import { ButtonAction } from '../ButtonAction/ButtonAction.js';

var ChoiceCards = props => {
  var fieldsetAttributes = {
    className: 'form-group choicecards',
    id: props.id
  };
  var ErrorMessageComponent;
  var HelpTextComponent;
  if (typeof props.isValid === 'boolean' && props.isValid === false) {
    // Invalid
    fieldsetAttributes.className += ' is-invalid';
    // @ts-ignore
    fieldsetAttributes['aria-invalid'] = true;

    // Invalid with error message
    if (props.errormessage) {
      // @ts-ignore
      fieldsetAttributes['aria-describedby'] = "".concat(props.id, "-errormessage");
      ErrorMessageComponent = /*#__PURE__*/React.createElement(ErrorMessage, {
        id: props.id,
        message: props.errormessage
      });
    }
  } else if (props.helptext) {
    // @ts-ignore
    fieldsetAttributes['aria-describedby'] = "".concat(props.id, "-helptext");
    HelpTextComponent = /*#__PURE__*/React.createElement(HelpText, {
      id: props.id
    }, props.helptext);
  }
  var onChange = null;
  if (typeof props.onChange === 'function') {
    onChange = (name, value, event) => {
      var updatedValues = {};
      if (props.type === 'radio') {
        updatedValues[name] = value;
      } else {
        updatedValues = _objectSpread2({}, props.value);
        if (value) {
          updatedValues[name] = true;
        } else {
          // Don't store false values in the object
          delete updatedValues[name];
        }
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      props.onChange(props.name, updatedValues, event);
    };
  }
  var {
    description
  } = props;
  if (typeof description === 'string') {
    if (description.substr(0, 1) !== '<') {
      // Wrap in a paragraph if it's not inside some type of HTML
      description = "<p>".concat(description, "</p>");
    }
    // Sanitize HTML
    // eslint-disable-next-line react/no-danger
    description = /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: sanitize(description)
    });
  }
  var hcid = "".concat(ChoiceCards.name.toLocaleLowerCase(), "-").concat("10.6.2");
  var getLabel = () => props.headingTag ? /*#__PURE__*/React.createElement(props.headingTag, null, props.label) : props.label;
  var getLegend = () => props.addTabIndex ? /*#__PURE__*/React.createElement("legend", {
    id: "".concat(props.id, "-legend"),
    tabIndex: -1
  }, getLabel()) : /*#__PURE__*/React.createElement("legend", null, getLabel());
  return /*#__PURE__*/React.createElement("fieldset", _extends({}, fieldsetAttributes, {
    "data-hcid": hcid
  }), props.label && getLegend(), description, HelpTextComponent, ErrorMessageComponent, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'form-group-error mt-2 mt-lg-2 pt-1': !props.isValid
    }, {
      'mt-1': props.isValid && HelpTextComponent
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, props.options.map(option => {
    var name = props.type === 'radio' ? "".concat(props.name) : "".concat(props.id, "-").concat(option.id);
    var choicecard = {
      checked: !!props.value[option.value],
      children: option.children,
      description: option.description,
      displaySelectField: props.displaySelectField,
      fullVersion: props.fullVersion,
      id: "".concat(props.id, "-").concat(option.id),
      imageSrc: option.imageSrc,
      minimizedVersion: props.minimizedVersion,
      name,
      onChange,
      pictogram: option.pictogram,
      pictogramTheme: option.pictogramTheme,
      selectText: props.selectText || 'Choose',
      smallerOnMobile: props.smallerOnMobile,
      title: option.title,
      type: props.type,
      value: option.value
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "col-12 mb-2 mb-lg-3 ".concat(props.cardsGridClasses ? props.cardsGridClasses : ''),
      key: "choicecard-".concat(props.id, "-").concat(option.value)
    }, /*#__PURE__*/React.createElement(ChoiceCard, choicecard));
  }))), props.buttons && /*#__PURE__*/React.createElement("div", {
    className: "pt-3"
  }, props.buttons.map((buttonAttributes, index) => /*#__PURE__*/React.createElement(ButtonAction, _extends({}, buttonAttributes, {
    key: "choicecards-".concat(props.id, "-buttons-").concat(index + 1)
  })))));
};
ChoiceCards.defaultProps = {
  cardsGridClasses: 'col-md-6 col-lg-3',
  isValid: true
};
ChoiceCards.propTypes = {
  button: PropTypes.array,
  cardsGridClasses: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  displaySelectField: PropTypes.bool,
  errormessage: PropTypes.string,
  headingTag: PropTypes.oneOf(HtmlHeadings),
  helptext: PropTypes.string,
  id: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
  label: PropTypes.string,
  minimizedVersion: PropTypes.bool,
  fullVersion: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  selectText: PropTypes.string,
  smallerOnMobile: PropTypes.bool,
  value: PropTypes.object
};

export { ChoiceCards };
